import { apiService } from './api';

const API = '/automobile/vehicles';

export const autoMobileVehicleService = {
  getAll: () => apiService.get<any>(API),
  getById: (id: number) => apiService.get<any>(`${API}/${id}`),
  create: (data: any) => apiService.post<any>(API, data),
  update: (id: number, data: any) => apiService.put<any>(`${API}/${id}`, data),
  delete: (id: number) => apiService.delete<any>(`${API}/${id}`),
};
